import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "utils/ApiUrl";

import "./badges.scss";
import Loader from "utils/loader";
import NftMainCard from "./NftMainCard";
import SendClaimBatch from "hooks/dataSenders/sendClaimBatch";
import { toast } from "react-toastify";
import useWeb3 from "hooks/useWeb3";
import { useWeb3React } from "@web3-react/core";
import useFetchUserData from "hooks/useAuthUserData";
import { CallMerge } from "@material-ui/icons";
import useTimer from "./Timer";
import { fetchBatchData } from "./batchDataUtils";
import Sucessmodal from "utils/SuccessModal";

const Badges = () => {
  const web3 = useWeb3();
  const { account } = useWeb3React();

  const useData = useFetchUserData();
  const user = useData?.data?.data;
  console.log("USERS DATA :", user);

  const { claimBatch } = SendClaimBatch();
  // const [batchData, setBatchData] = useState([]);

  const [refresh, setRefresh] = useState(false);

  const [userNfts, setUsersNfts] = useState([]);
  const [offset, setOffset] = useState(1); // page number
  const [limit] = useState(100); // items per page
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingNfts, setLoadingNfts] = useState(false);
  const [claiming, setClaiming] = useState(false);
  const [showClaimAllSuccessModal, setShowClaimAllSuccessModal] =
    useState(false);

  // Fetch nfts from API
  const fetchUsersNFTs = async () => {
    setLoadingNfts(true);
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.get(`${API_URL}/nfts`, {
        params: { offset, limit },
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "content-type": "application/json",
        },
      });
      const data = response?.data?.data;
      // console.log("Transaction api response: ", response);
      console.log("userNfts data : ", data.nfts);
      setUsersNfts(data.nfts);
      setTotalItems(data.count); // Total number of items
      setTotalPages(data.pages); // Total pages from API
    } catch (error) {
      console.error("Error fetching userNfts:", error);
    } finally {
      setLoadingNfts(false);
    }
  };

  const handleClaimAll = async () => {
    if (account) {
      if (account?.toLowerCase() == user?.walletAddress) {
        await fetchUsersNFTs();
        const batchData = await fetchBatchData(userNfts, setLoading);

        if (!batchData || batchData.tokenIds.length === 0) {
          toast.error("No claims available!");
          return;
        }

        const { tokenIds, amounts, nextClaimPeriods, deadline, signature } =
          batchData;

        console.log(
          "returned batch data : ",
          tokenIds,
          amounts,
          nextClaimPeriods,
          deadline,
          signature
        );

        try {
          setClaiming(true);
          const contractResponse = await claimBatch(
            tokenIds,
            amounts,
            nextClaimPeriods,
            deadline,
            signature
          );
          if (contractResponse) {
            try {
              const accessToken = window.localStorage.getItem("accessToken");
              const response = await axios.post(
                `${API_URL}/claims/add-claims`,
                { transactionHash: contractResponse.transactionHash },
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                  },
                }
              );
              await fetchUsersNFTs();
              console.log("Sending transactionHash", response?.data);
            } catch (error) {
              console.log(
                "Error during claim transaction response: " + error?.message
              );
            }

            toast.success("Claim all successful!");
            setShowClaimAllSuccessModal(true);
          }
        } catch (error) {
          console.error("Error during batch claim:", error.message);
          toast.error("Something went wrong during batch claim!");
        } finally {
          setClaiming(false);
        }
      } else {
        toast.error(
          "Wrong wallet address. Please connect wallet associated with the account"
        );
      }
    } else {
      toast.error("Connect your wallet");
    }
  };

  useEffect(() => {
    fetchUsersNFTs();
  }, [offset, limit, refresh]);

  // Pagination logic
  const handlePageChange = (page) => {
    setOffset(page);
  };

  const hasClaimableNfts = userNfts?.some(
    (nft) => nft?.isMoreThan30Days && Number(nft?.claimAmount) !== 0
  );

  return (
    <>
      <Sucessmodal
        show={showClaimAllSuccessModal}
        handleClose={() => setShowClaimAllSuccessModal(false)}
      />
      {loading || claiming || loadingNfts ? (
        <>
          {claiming && <Loader text={"Sending claim request"} />}
          {(loading || loadingNfts) && <Loader />}
        </>
      ) : (
        <>
          <section className="mainachievements ourteam ">
            {userNfts?.length !== 0 && (
              <button
                style={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  background: "#FF8A00",
                  color: "#FFF",
                  fontSize: "14px",
                  fontWeight: 600,
                  borderRadius: "30px",
                  border: "none",
                  outline: "none",
                  opacity: hasClaimableNfts ? 1 : 0.5,
                }}
                onClick={handleClaimAll}
                disabled={!hasClaimableNfts}
              >
                Claim All
              </button>
            )}
            <div className="mainsssparents">
              {/* Claim All Button */}

              <div className="ourteammainouter_div2">
                {userNfts.map((userNft) => (
                  <NftMainCard
                    userNft={userNft}
                    user={user}
                    fetchUsersNFTs={fetchUsersNFTs}
                    setClaiming={setClaiming}
                    setLoading={setLoading}
                  />
                ))}
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default Badges;
